import styled, { css } from 'styled-components';
import Menu from '@mui/material/Menu';

export const Div = styled.div<{ $isOpen: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  margin: 0 auto;
  z-index: 1;
  width: 100%;
  margin-right: 2px;

  svg {
    display: block;
  }

  &:before {
    content: '';
    width: 40px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    cursor: pointer;
    #p-bg {
      fill: #fd563052;
    }
    #p-icon {
      fill: ${({ theme }) => theme.colors.gp1};
      stroke: ${({ theme }) => theme.colors.gp1};
    }
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      #p-bg {
        fill: #fd563052;
      }
      #p-icon {
        fill: ${({ theme }) => theme.colors.gp1};
        stroke: ${({ theme }) => theme.colors.gp1};
      }
    `}
`;

export const StyledMenu = styled(Menu)`
  .MuiList-padding {
    padding: 0 !important;
  }
  & .MuiPaper-root {
    border-radius: 3px;
    box-shadow: 0px 0px 37px ${({ theme }) => theme.colors.shadow};
  }

  .gtcs-options {
    right: 0;
    padding-top: 18px;
    min-width: 250px;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    cursor: default;
    display: grid;
    grid-gap: 10px;
    user-select: none;
    box-shadow: 0px 0px 37px ${({ theme }) => theme.colors.shadow};
    z-index: 100;

    &__title {
      font-size: 14px;
      color: ${({ theme }) => theme.colors.cflowerBlue};
      margin: 0 20px;
      margin-bottom: 4px;
    }

    &__item {
      padding: 0 20px;
      display: flex;
      grid-gap: 10px;
      cursor: pointer;
      overflow: hidden;

      &__title {
        color: ${({ theme }) => theme.colors.cflowerBlue};
        font-weight: 500;
        font-size: 14px;
      }
    }

    &__clear {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      border-top: 1px solid ${({ theme }) => theme.colors.stroke};
      background-color: ${({ theme }) => theme.colors.cultured};
      margin-top: 4px;
      p {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.cflowerBlue};
      }

      &:hover {
        cursor: pointer;
        background: ${({ theme }) => theme.colors.gradient};
        span {
          color: ${({ theme }) => theme.colors.btnWhite};
        }
      }
    }
  }
`;
